module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-9-d29414a1aa70d64da432b5a8caed7ff3.png";